<template>
  <BaseSelect
    v-model="toy"
    :options="options"
    :reduce="reduce"
    :validation="validation"
  />
</template>

<script>
import { mapState } from 'vuex'
import BaseSelect from '@/components/BaseSelect'

export default {
  name: 'ToySelectWithRents',
  components: { BaseSelect },
  props: {
    value: {
      type: [Number, Object],
      default: null
    },
    validation: {
      type: Object,
      default: () => ({})
    },
    filter: {
      type: Function,
      default: (toys) => toys
    },
    reduce: {
      type: Function,
      default: ({ code }) => code
    },
    storeId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    ...mapState('multiStoresSse', ['toyUpdates']),

    // Getter/setter para suportar v-model
    toy: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    // Extrai o array de brinquedos do payload SSE (toyUpdates[storeId].toys)
    toys() {
      const storeData = this.toyUpdates[this.storeId] || {}
      // Garante que toys seja sempre um array
      return Array.isArray(storeData.toys) ? storeData.toys : []
    },

    // Mapeia para options que o BaseSelect espera
    options() {
      return this.filter(this.toys).map(({ id, name }) => ({
        code: id,
        label: name
      }))
    }
  }
}
</script>
